// Press feedback (01-design.md, Motion, v1.58.24): list rows, cards and buttons are marked
// `data-pressed` while pressed (pointer down, or Space or Enter held on the focused one) until release,
// a cancelled touch or the pointer leaving (nothing stays pressed, 07, v1.58.31); blocks.css scales the
// drawing. Nothing on a disabled control or in a field.
const PRESSABLE = '.btn, .icon-btn, .tab, .row, .member-row, .picker-row, .switcher-row, .result-card, .settings-card, .settings-entry';

let pressed: Element | undefined;
const release = () => {
  pressed?.removeAttribute('data-pressed');
  pressed = undefined;
};

function press(target: EventTarget | null, keyboard: boolean) {
  release();
  if (!(target instanceof Element) || target.closest('input, textarea, select, [contenteditable]')) return;
  // By keyboard only the focused one itself (a side-list row through its link), never a card around a control.
  const el = keyboard ? (target.matches(PRESSABLE) ? target : target.closest('.row-link')?.closest('.row')) : target.closest(PRESSABLE);
  if (!el || el.matches(':disabled, [aria-disabled="true"]')) return;
  pressed = el;
  el.setAttribute('data-pressed', '');
}

export function startPressing(): void {
  addEventListener('pointerdown', (e) => !e.button && press(e.target, false), true);
  addEventListener('keydown', (e) => (e.key === 'Enter' || e.key === ' ') && !e.repeat && press(e.target, true), true);
  // The window's own blur only: captured, the focus leaving another element on the same press would end it.
  for (const type of ['pointerup', 'pointercancel', 'touchcancel', 'keyup', 'blur', 'dragstart']) addEventListener(type, release, type !== 'blur');
  addEventListener('pointerout', (e) => pressed && !pressed.contains(e.relatedTarget as Node | null) && release(), true);
}
